import { useState } from "react";

const TeachedLabels = ({ title, items }) => {
  const [isOpen, setIsOpen] = useState(false);
  const half = Math.ceil(items.length / 2);
  const firstHalf = items.slice(0, half);
  const secondHalf = items.slice(half);

  const toggleTable = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div style={{ marginBottom: "20px", marginTop: "10px" }}>
      <button
        onClick={toggleTable}
        style={{
          display: "block",
          width: "100%",
          padding: "10px",
          marginBottom: "10px",
          border: "1px",
          borderRadius: 10,
          backgroundColor: "#a61ed6",
          color: "white",
          cursor: "pointer",
          fontSize: 25,
        }}
      >
        {title} 教えた一覧
      </button>
      {isOpen && (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid black",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  verticalAlign: "top",
                  padding: "10px",
                  border: "1px solid black",
                }}
              >
                <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                  {firstHalf.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </td>
              <td
                style={{
                  verticalAlign: "top",
                  padding: "10px",
                  border: "1px solid black",
                }}
              >
                <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                  {secondHalf.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TeachedLabels;
